import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import {parsePlayerExposureValue} from 'helpers/number-helper';
import {preparePlayersExposure} from 'helpers/player-helper';
import Action from 'actions';
import Const from 'constants';
import InputText from 'components/atoms/inputs/input-text';

class PlayerExposure extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {value: null};
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(value) {
        const {propName, mode = Const.DEFAULT_MODE} = this.props;
        const player = this.getPlayer();
        value = parsePlayerExposureValue(value, propName);

        this.onChange(value);
        this.isValueBeingChanged = false;

        const exposure = preparePlayersExposure([player], player.getPropNameOfMode(propName, mode), value, mode);

        this.props.dispatch(Action.set('PlayersExposure', exposure));
    }

    getPlayer() {
        const {players, playerId} = this.props;
        return players.getPlayer(playerId);
    }

    render() {
        const {propName, className, mode = Const.DEFAULT_MODE, testId} = this.props;
        const player = this.getPlayer();
        const value = this.isValueBeingChanged ? this.state.value : player.getPropValueOfMode(propName, mode);

        return (
            <InputText
                percent
                value={value}
                className={className}
                onChange={::this.onChange}
                onBlur={::this.onBlur}
                testId={testId}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {players} = state.playersData;

    return {
        players,
    };
}

export default connect(mapStatesToProps)(PlayerExposure);
